






export default {
  name: 'basic-div'
}
